/**
 * The ops plane's own navigation, composed from whichever areas exist
 * in this build (`src/ops/routes/index.ts`'s glob) -- an area registers by
 * creating its own `routes.ts`, never by editing this file.
 */

import type { ReactNode } from 'react';

import { ShellNav } from '../../chrome/shell';
import { defineCatalogue } from '../../i18n';
import type { OpsNavEntry } from '../routes/contract';

const catalogue = defineCatalogue(
  { 'nav.label': 'Navegação do operador' },
  { 'nav.label': 'Operator navigation' },
);

// `entries` always carries at least one area: `routes/index.ts`'s
// `import.meta.glob` is resolved at build time, and every build registers
// at least one `src/ops/<area>/routes.ts` (`[dead-key-dead-route]`).
export function OpsNav(props: { entries: OpsNavEntry[] }): ReactNode {
  return (
    <ShellNav
      label={catalogue.t('nav.label')}
      groups={[
        {
          label: null,
          items: props.entries.map((entry) => ({
            path: entry.path,
            label: entry.label(),
            icon: entry.icon,
          })),
        },
      ]}
    />
  );
}
